import type { ImageResolutionsInterface } from '@kimuno/api-sdk';
import { Box } from '@mui/material';

import { spaces } from '../../assets/styles/themes/tokens';
import SelectablePage from './SelectablePage';

interface MindItemPageSelectionDialogContent {
	handlePageClick: (index: number) => void;
	mindItemPages: ImageResolutionsInterface[];
	selectedPages: number[];
}

const MindItemPageSelectionDialogContent = (props: MindItemPageSelectionDialogContent) => {
	const { handlePageClick, mindItemPages, selectedPages } = props;

	return (
		<Box
			sx={{
				width: '100%',
				display: 'inline-flex',
				position: 'relative',
			}}
		>
			{mindItemPages.map((page, index) => {
				return (
					<SelectablePage
						// biome-ignore lint/suspicious/noArrayIndexKey: index keys are pre-existing; switching the key source changes reconciliation behavior
						key={index}
						page={page}
						index={index}
						handlePageClick={handlePageClick}
						isPageSelected={selectedPages.includes(index)}
						marginRight={index === mindItemPages.length - 1 ? '0px' : spaces.xs}
					/>
				);
			})}
		</Box>
	);
};

export default MindItemPageSelectionDialogContent;
